import {
    SkeletonBodyText,
    SkeletonDisplayText,
    SkeletonThumbnail
} from '@shopify/polaris';
import { Table } from 'antd';
import React from 'react';
import { columnsVariant } from './constents';

export const rows: any = Array.from({ length: 9 }).map((_, ind) => ({
    key: ind + 1,
    variant_title: <SkeletonBodyText lines={2} />,
    image: <SkeletonThumbnail size="medium" />,
    sku: <SkeletonBodyText lines={1} />,
    barcode: <SkeletonBodyText lines={1} />,
    asin: <SkeletonBodyText lines={1} />,
    fulfilment: <SkeletonBodyText lines={1} />,
    quantity: <SkeletonBodyText lines={1} />,
    status: (
        <div className="Custom__Status--Skeleton">
            <SkeletonDisplayText size="small" />
        </div>
    ),
    activity: (
        <div className="Custom__Activity--Skeleton custom-variant-grid__activity-skelton">
            <SkeletonDisplayText size="small" />
        </div>
    ),
    price: (
        <SkeletonBodyText lines={1} />
    ),
    feed: (
        <div className="Custom__Feed--Skeleton">
            <SkeletonThumbnail size="extraSmall" />
        </div>
    ),
}));

const VariantTableSkelton = ({ t }: any) => {
    return (
        <div>
            <Table
                columns={columnsVariant(t)}
                dataSource={rows}
                rowSelection={{ selectedRowKeys: [] }}
                pagination={false}
                size="middle"
                scroll={{ x: 700 }}
                sticky
            />
        </div>
    );
};

export default VariantTableSkelton;
